import { handleAction } from 'redux-actions';
import { compose, defaultTo, find, test as rTest } from 'ramda';
import Immutable from 'seamless-immutable';

import { DETECT_THEME } from './actions';

const PRODUCT_THEMES = Immutable(['dietbet', 'stepbet', 'runbet', 'sweatbet']);

export const THEMES = Immutable(['waybetter', ...PRODUCT_THEMES]);

export const INITIAL_STATE = THEMES[0];

export default handleAction(
  DETECT_THEME,
  (state, { payload }) =>
    compose(
      defaultTo(INITIAL_STATE),
      find((theme) => rTest(new RegExp(theme, 'i'), payload))
    )(PRODUCT_THEMES),
  INITIAL_STATE
);
